module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "version-file-download"
  }, [_c('h2', [_vm._v("请选择应用类型")]), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('label', {
    staticClass: "form-item-label required"
  }, [_vm._v("选择版本")]), _vm._v(" "), _c('div', {
    staticClass: "form-item-content"
  }, [_c('bk-selector', {
    attrs: {
      "list": _vm.versionList,
      "selected": _vm.versionType
    },
    on: {
      "update:selected": function($event) {
        _vm.versionType = $event
      },
      "item-selected": _vm.onVersionSelect
    }
  })], 1)]), _vm._v(" "), (_vm.versionType === 'communityCustomization') ? [_c('div', {
    staticClass: "form-item"
  }, [_c('label', {
    staticClass: "form-item-label required"
  }, [_vm._v("用户代号")]), _vm._v(" "), _c('div', {
    staticClass: "form-item-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appCode),
      expression: "appCode"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.appCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.appCode = $event.target.value
      }, _vm.onAppCodeInput]
    }
  }), _vm._v(" "), (_vm.errors.appCode) ? _c('span', {
    staticClass: "error-msg"
  }, [_vm._v("请填写用户代号")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('label', {
    staticClass: "form-item-label required"
  }, [_vm._v("用户证书")]), _vm._v(" "), _c('div', {
    staticClass: "form-item-content"
  }, [_c('input', {
    ref: "userCredential",
    staticClass: "upload-input",
    attrs: {
      "type": "file",
      "accept": ".cert"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('button', {
    class: ['bk-button', 'bk-primary', {
      'is-loading': _vm.uploading
    }],
    on: {
      "click": _vm.onCredentialUpload
    }
  }, [_vm._v("上传")]), _vm._v(" "), (_vm.errors.userCredential) ? _c('span', {
    staticClass: "error-msg"
  }, [_vm._v("请上传用户证书")]) : _vm._e()])])] : _vm._e(), _vm._v(" "), (_vm.versionType === 'enterpriseSpecial') ? [_c('div', {
    staticClass: "form-item"
  }, [_c('label', {
    staticClass: "form-item-label required"
  }, [_vm._v("选择企业")]), _vm._v(" "), _c('div', {
    staticClass: "form-item-content"
  }, [_c('bk-selector', {
    attrs: {
      "list": _vm.enterpriseList,
      "selected": _vm.appCode,
      "setting-key": 'company_code',
      "displayKey": 'company'
    },
    on: {
      "update:selected": function($event) {
        _vm.appCode = $event
      },
      "item-selected": function($event) {
        _vm.errors.appCode = false
      }
    }
  }), _vm._v(" "), (_vm.errors.appCode) ? _c('span', {
    staticClass: "error-msg"
  }, [_vm._v("请选择企业")]) : _vm._e()], 1)])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "form-action"
  }, [_c('a', {
    staticClass: "bk-button bk-primary",
    attrs: {
      "title": "确定"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_c('span', [_vm._v("确定")])]), _vm._v(" "), _c('a', {
    staticClass: "bk-button",
    attrs: {
      "title": "取消"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('span', [_vm._v("取消")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-60d49560!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/works/version_file_download.vue
// module id = CIOP
// module chunks = 16